export const getDropdownKey = (feedbackAlias: string, field: string) => {
  return `feedback-detail-${feedbackAlias}-${field}-dropdown`;
};
